import React from "react";
import { Modal, Button, ListGroup, Form } from "react-bootstrap";
import axios from "axios";

const DoctorApprovalModal = ({
  show,
  onHide,
  selectedQuery,
  setSelectedQuery,
  refreshQueries,
  doctor
}) => {
  const handleApprovalChange = (e) => {
    setSelectedQuery((prev) => ({
      ...prev,
      doctor_approved: e.target.checked ? 1 : 0,
    }));
  };

  const handleRemarksChange = (e) => {
    setSelectedQuery((prev) => ({
      ...prev,
      remarks: e.target.value,
    }));
  };

  const handleSave = async () => {
    try {
      // Step 1: Update approval and remarks
      const res = await axios.post(
        "https://ricgop.online/api/update-doctor-approval.php",
        {
          id: selectedQuery.id,
          doctor_approved: selectedQuery.doctor_approved,
          remarks: selectedQuery.remarks || "",
          doctor_id: selectedQuery.doctor_id,
          date: selectedQuery.date,
          time: selectedQuery.time,
        }
        
      );

      // Step 2: If approved, mark slot as booked
      if (res.data.success && selectedQuery.doctor_approved == 1) {
        const slotRes = await axios.post("https://ricgop.online/api/update-slot-booked.php", {
          doctor_id: doctor.id,
          date: selectedQuery.date,
          time: selectedQuery.time,
        });
      }
    
      if (res.data.success) {
        alert(
          res.data.email_sent
            ? "Appointment approved and email sent."
            : "Appointment approved, email not sent."
        );

        await refreshQueries();

        // Fetch updated data for immediate UI update
        const updated = await axios.get(
          `https://ricgop.online/api/get-doctor-query.php?id=${selectedQuery.id}`
        );
        setSelectedQuery(updated.data);
      } else {
        alert("Update failed.");
      }
    } catch (err) {
      console.error(err);
      alert("Error saving approval.");
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="modern-modal">
      <Modal.Header closeButton className="modal-header-custom">
        <Modal.Title className="modal-title-custom">🩺 Patient Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-custom">
        {selectedQuery ? (
          <ListGroup variant="flush">
            <ListGroup.Item>
              <strong>Full Name: </strong> {selectedQuery.patient_name}
            </ListGroup.Item>
            <ListGroup.Item>
              <strong>Email: </strong> {selectedQuery.patient_email}
            </ListGroup.Item>
            {/* <ListGroup.Item>
              <strong>Service: </strong> {selectedQuery.service}
            </ListGroup.Item> */}
            <ListGroup.Item>
              <strong>Date: </strong> {selectedQuery.date}
            </ListGroup.Item>
            <ListGroup.Item>
              <strong>Time: </strong> {selectedQuery.time}
            </ListGroup.Item>
            <ListGroup.Item>
              <strong>Explanation: </strong> {selectedQuery.explanation}
            </ListGroup.Item>
            {selectedQuery.document && (
              <ListGroup.Item>
                <strong>Document: </strong>
                <a
                  href={`../assets/uploads/${selectedQuery.document}`}
                  target="_blank"
                  rel="noreferrer"
                  className="document-link"
                >
                  View File
                </a>
              </ListGroup.Item>
            )}
            <ListGroup.Item>
              <Form.Group>
                <Form.Label>
                  <strong>Give Remarks To Patient:</strong>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Write your remarks for the patient here..."
                  value={selectedQuery.remarks || ""}
                  onChange={handleRemarksChange}
                />
              </Form.Group>
            </ListGroup.Item>
            <ListGroup.Item>
              <input
                type="checkbox"
                id="approvalCheckbox"
                checked={selectedQuery.doctor_approved === 1}
                onChange={handleApprovalChange}
              />
              <label htmlFor="approvalCheckbox" className="ms-2 fw-medium">
                Approve this Appointment
              </label>
            </ListGroup.Item>
          </ListGroup>
        ) : (
          <p>No query selected</p>
        )}
      </Modal.Body>
      <Modal.Footer className="modal-footer-custom">
        <Button variant="success" onClick={handleSave}>
          Save Approval
        </Button>
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DoctorApprovalModal;
